import type { ProductEntity } from "./PoductEntity";

export interface AchievementEntity {
  achievementId: string;
  achievementCode: string;
  achievementName: string;
  refMemo: string;
  company: string;
  description: string;
  conditionsToAchieve: string;
  receiveRewardType: string;
  startDate: string;
  endDate: string;
  rule: string;
  status: string;
  imageUrl: string;
  documentUrl: string;
  isGroup: boolean;
  isApproved: boolean;
  isDeleted: boolean;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  achievementProductCount: number;
  achievementShopCount: number;
  achievementMainRewardCount: number;
  achievementSpecialRewardCount: number;
  thisStatus: string;
}
export const AchievementEntity_INIT: AchievementEntity = {
  achievementId: "",
  achievementCode: "",
  achievementName: "",
  refMemo: "",
  company: "",
  description: "",
  conditionsToAchieve: "",
  receiveRewardType: "",
  startDate: "",
  endDate: "",
  rule: "",
  status: "",
  imageUrl: "",
  documentUrl: "",
  isGroup: false,
  isApproved: false,
  isDeleted: false,
  updatedBy: "",
  createdAt: "",
  updatedAt: "",
  achievementProductCount: 0,
  achievementShopCount: 0,
  achievementMainRewardCount: 0,
  achievementSpecialRewardCount: 0,
  thisStatus: "",
};
export interface StatusEntity {
  ALL: string;
  WAIT_APPROVE: string;
  ACTIVE: string;
  PENDING: string;
  INACTIVE: string;
  EXPIRE: string;
}
export const StatusEntity_INIT: StatusEntity = {
  ALL: "",
  WAIT_APPROVE: "",
  ACTIVE: "",
  PENDING: "",
  INACTIVE: "",
  EXPIRE: "",
};

export interface badgeMasterEntity {
  badgeMasterId: string;
  badgeMasterName: string;
  badgeImageUrl: string;
  company: string;
  isActive: boolean;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface AchieveMainReward {
  mainRewardId: string;
  mileStoneName: string;
  rewardName: string;
  rewardNum: number;
  badgeImageUrl: string;
  badgeMaster: badgeMasterEntity;
  imageUrl: string;
  targetAmount: string;
  targetUnit: string;
  isActive: boolean;
  detail: string;
  achievementRewardId: string;
  createdAt: string;
  updatedAt: string;
}
export interface AchieveSpecialReward {
  specialRewardId: string;
  unlockMainRewardNum: string;
  mileStoneSpecialName: string;
  badgeImageUrl: string;
  badgeMaster: badgeMasterEntity;
  specialRewardName: string;
  specialRewardNum: number;
  receiveRewardType: string;
  imageUrl: string;
  targetAmount: string;
  targetUnit: string;
  isActive: boolean;
  detail: string;
  achievementRewardId: string;
  createdAt: string;
  updatedAt: string;
}
export interface AchieveRewardEntity {
  achievementRewardId: string;
  isSpecial: boolean;
  achievementId: string;
  achievementGroupId: string;
  createdAt: string;
  updatedAt: string;
  achievementMainReward: AchieveMainReward[];
  achievementSpecialReward: AchieveSpecialReward[];
  receiveSpecialRewardType?: string;
}
export interface DetailAchieveEntity {
  achievementId: string;
  achievementCode: string;
  achievementName: string;
  refMemo: string;
  company: string;
  description: string;
  conditionsToAchieve: string;
  receiveRewardType: string;
  startDate: string;
  endDate: string;
  rule: string;
  status: string;
  imageUrl: string;
  documentUrl: string;
  isGroup: boolean;
  isApproved: boolean;
  isDeleted: boolean;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  achievementReward: AchieveRewardEntity[];
  documentFilenameText: string;
  thisStatus: string;
}
export interface achieveShopEntity {
  achievementShopId: string;
  customerCompanyId: number;
  customerType: string;
  customerName: string;
  customerNo: string;
  customerZone: string;
  customerGroupName: string;
  isActive: boolean;
  achievementId: string;
  achievementGroupId: string;
  achievementRewardId: string;
  createdAt: string;
  updatedAt: string;
}
export interface achieveProdEntity {
  achievementProductId: string;
  productId: number;
  productName: string;
  productCode: string;
  productGroup: string;
  saleUom: string;
  saleUomTh: string;
  isActive: boolean;
  imageProduct: string;
  achievementId: string;
  achievementGroupId: string;
  achievementRewardId: string;
  createdAt: string;
  updatedAt: string;
}

//detail ติดตามความมสำเร็จ
export interface followAchievement {
  achievementName: string;
  achievementShopCount: number;
  conditionsToAchieve: string;
  daysPassed: number;
  endDate: string;
  mainRewardAll: [];
  specialRewardAll: [];
  startDate: string;
}
export interface followAchievementShop {
  currentMilestoneName: string;
  currentRewardNum: string;
  currentSpecialMilestoneName: string;
  currentSpecialRewardNum: string;
  customerCompanyId: number;
  customerName: string;
  customerNo: string;
  customerType: string;
  customerZone: string;
  progressValue: string;
  remainingToNext: string;
}
export const followAchievementShop_INIT: followAchievementShop = {
  currentMilestoneName: "",
  currentRewardNum: "",
  currentSpecialMilestoneName: "",
  currentSpecialRewardNum: "",
  customerCompanyId: 0,
  customerName: "",
  customerNo: "",
  customerType: "",
  customerZone: "",
  progressValue: "",
  remainingToNext: "",
};

// detail shop
export interface shopDetailAchieveEntity {
  achievementId: string;
  achievementCode: string;
  achievementName: string;
  conditionsToAchieve: string;
  receiveRewardType: string;
  startDate: string;
  endDate: string;
  status: string;
  rule: string;
  description: string;
  imageUrl: string;
  company: string;
  customerType: string;
  customerName: string;
  customerCompanyId: number;
  customerNo: string;
  currentMilestoneName: string;
  currentRewardNum: number;
  currentTargetAmount: string;
  currentRewardName: string;
  currentBadgeImageUrl: string;
  currentBadgeMasterUrl: string;
  currentBadgeMasterId: string;
  currentBadgeMasterName: string;
  nextMilestoneName: string;
  nextRewardNum: string;
  nextTargetAmount: string;
  nextRewardName: string;
  progressValue: string;
  remainingToNext: string;
  isSpecial: boolean;
  isFinishMain: boolean;
  unlockMainRewardNum: string;
  currentMilestoneSpecialName: string;
  currentSpecialRewardName: string;
  currentSpecialRewardNum: number;
  currentSpecialTargetAmount: string;
  nextSpecialTargetAmount: string;
  nextMilestoneSpecialName: string;
  nextSpecialRewardName: string;
  nextSpecialRewardNum: number;
  isFinishSpecial: boolean;
  mainReward: AchieveMainReward[];
  specialReward: AchieveSpecialReward[];
}

export interface productDetailOrderEntity {
  cnNo: string;
  amount: number;
  saleUOM: string;
  cnAmount: number;
  createAt: string;
  quantity: number;
  unitName: string;
  updateAt: string;
  isFreebie: boolean;
  productId: number;
  isCanceled: boolean;
  productName: string;
  isParticipate: boolean;
  productCodeNAV: string;
  productCommonName: string;
  orderAchievementId: string;
  orderAchievementProductId: string;
  productImage: string;
  packSize: string;
}
export const productDetailOrderEntity_INIT: productDetailOrderEntity = {
  cnNo: "",
  amount: 0,
  saleUOM: "",
  cnAmount: 0,
  createAt: "",
  quantity: 0,
  unitName: "",
  updateAt: "",
  isFreebie: false,
  productId: 0,
  isCanceled: false,
  productName: "",
  isParticipate: false,
  productCodeNAV: "",
  productCommonName: "",
  orderAchievementId: "",
  orderAchievementProductId: "",
  productImage: "",
  packSize: "",
};
export interface shopDetailOrderEntity {
  orderAchievementId: string;
  customerCompanyId: number;
  company: string;
  customerName: string;
  customerNo: string;
  customerZone: string;
  customerGroupName: string;
  customerTaxNo: string;
  userType: string;
  dateDelivery: string;
  status: string;
  sumAmount: string;
  sumQuantity: string;
  pdoNo: string;
  soNo: string;
  doNo: string;
  queueId: string;
  reason: string;
  createAt: string;
  updateAt: string;
  sumAmountOrder: string;
  sumQuantityOrder: string;
  productCount: string;
  productList: productDetailOrderEntity[];
}
export const shopDetailOrderEntity_INIT: shopDetailOrderEntity = {
  orderAchievementId: "",
  customerCompanyId: 0,
  company: "",
  customerName: "",
  customerNo: "",
  customerZone: "",
  customerGroupName: "",
  customerTaxNo: "",
  userType: "",
  dateDelivery: "",
  status: "",
  sumAmount: "",
  sumQuantity: "",
  pdoNo: "",
  soNo: "",
  doNo: "",
  queueId: "",
  reason: "",
  createAt: "",
  updateAt: "",
  sumAmountOrder: "",
  sumQuantityOrder: "",
  productCount: "",
  productList: [productDetailOrderEntity_INIT],
};
export interface historyAchievementEntity {
  achievementId: string;
  activity: string;
  createAt: string;
  historyAchievementId: string;
  statusAfter: string;
  statusBefore: string;
  updateAt: string;
  updateBy: string;
}
export interface productDetailAchieveEntity {
  company: string;
  packSize: string;
  productCodeNAV: string;
  productCommonName: string;
  productId: number;
  productImage: string;
  productName: string;
  saleUOM: string;
  totalAmount: string;
  totalQuantity: string;
  unitName: string;
}
export const productDetailAchieveEntity_INIT: productDetailAchieveEntity = {
  company: "",
  packSize: "",
  productCodeNAV: "",
  productCommonName: "",
  productId: 0,
  productImage: "",
  productName: "",
  saleUOM: "",
  totalAmount: "",
  totalQuantity: "",
  unitName: "",
};
